import { Box } from '@chakra-ui/react';
import type { LucideIcon } from 'lucide-react';

/** Icon-only status toggle — the single button style across the whole
 *  status bar: the glyph stays neutral gray in both states; when ON the
 *  background lightens via the shared `bg.active` token and the glyph
 *  darkens to `text.primary` instead of coloring the icon. All colors
 *  are semantic tokens so the button reads correctly in both light and
 *  dark color modes. The action's name lives in the hover tooltip.
 *  `dimmed` renders the button at reduced opacity (e.g. per-type snap
 *  switches while the master OSNAP switch is off) without disabling it. */
export function IconToggle({ icon: Icon, on, onClick, title, dimmed = false }: { icon: LucideIcon; on: boolean; onClick: () => void; title: string; dimmed?: boolean }) {
    return (
        <Box
            as="button"
            px={2}
            py={0.5}
            borderRadius="sm"
            border="1px solid"
            borderColor="border.base"
            bg={on ? 'bg.active' : 'transparent'}
            color={on ? 'text.primary' : 'icon.base'}
            opacity={dimmed ? 0.45 : 1}
            cursor="pointer"
            userSelect="none"
            display="inline-flex"
            alignItems="center"
            flexShrink={0}
            transition="background 120ms ease, border-color 120ms ease, color 120ms ease, opacity 120ms ease"
            _hover={{ borderColor: 'border.hover' }}
            onClick={onClick}
            title={title}
            aria-label={title}
        >
            <Icon size={13} />
        </Box>
    );
}
